module.exports = __webpack_public_path__ + "img/totalValue5.9ffdd44.svg";